import updateScheduleView from 'services/store/schedules/actions/updateScheduleView';
import { makeAsyncActionCreator } from 'services/store/utils-actions';
import { collection, types } from 'services/store/todos/definitions';
import updateRemoteDocument from 'services/store/utils/actions/updateRemoteDocument';

async function maybeUpdateSchedule(dispatch, intent, start) {
  const schedule = intent.schedule;

  if (!schedule.views?.schedule) {
    return;
  }

  let blocks = schedule.views.schedule.blocks;

  // schedule
  if (!intent.start) {
    blocks = [
      ...blocks,
      {
        todo: intent.todo.id,
        start: start.toString(),
      }
    ];

  // reschedule
  } else if (start) {
    blocks = blocks.map(block => block.todo === intent.todo.id
      ? {
          ...block,
          start: start.toString(),
        }
      : block
    );

  // unschedule
  } else {
    blocks = blocks.filter(block => block.todo !== intent.todo.id);
  }

  return await dispatch(updateScheduleView(schedule, blocks));
}

const scheduleIntentImpl = makeAsyncActionCreator({
  type: types.SCHEDULE_TODO,
  creator: async (intent, start) => (
    await updateRemoteDocument(collection, intent.todo.id, {
      [`intents.${intent.scheduleId}.start`]: start
    })
  ),
  status: {
    path: collection,
    type: 'write',
    parameters: (intent, _start) => [ intent.id ],
  }
});

const scheduleIntent = (intent, start, skipScheduleUpdate = false) => async (dispatch) => {
  if (!skipScheduleUpdate) {
    await maybeUpdateSchedule(dispatch, intent, start);
  }

  return await dispatch(scheduleIntentImpl(intent, start));
};

export default scheduleIntent;
